import { render, staticRenderFns } from "./SelectCliente.vue?vue&type=template&id=2e1b10c5"
import script from "./SelectCliente.vue?vue&type=script&lang=js"
export * from "./SelectCliente.vue?vue&type=script&lang=js"
import style0 from "./SelectCliente.vue?vue&type=style&index=0&id=2e1b10c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports